import _ from 'lodash';

const fields = {
  name: {
    name: "name",
    error: "name",
    setField: "name",
  },
  background: {
    name: "backGround",
    error: "backGround",
    setField: "backGround",
  },
  backgroundColor: {
    name: "backgroundColor",
    error: "backgroundColor",
    setField: "backgroundColor",
  },
  submitBackground: {
    name: "submitPageBackground",
    error: "submitPageBackground",
    setField: "submitPageBackground",
  },
  landingPageBackground: {
    name: "landingPageBackground",
    error: "landingPageBackground",
    setField: "landingPageBackground",
  },
  landingPageHtml: {
    name: "html",
    error: "html",
    setField: "html",
  },
  landingPageTextColor: {
    name: "landTextColor",
    error: "landTextColor",
    setField: "landTextColor",
  },
  landingPageButtonColor: {
    name: "landBtnColor",
    error: "landBtnColor",
    setField: "landBtnColor",
  },
  thankyouPage: {
    name: "finalContent",
    error: "finalContent",
    setField: "finalContent",
  },
  usecase: {
    name: "casePopupData",
    error: "casePopupData",
    setField: "casePopupData",
  },
  textColor: {
    name: "textColor",
    error: "textColor",
    setField: "textColor",
  },
  buttonColor: {
    name: "btnColor",
    error: "btnColor",
    setField: "btnColor",
  },
  buttonTextColor: {
    name: "btnTextColor",
    error: "btnTextColor",
    setField: "btnTextColor",
  },
  loaderColor: {
    name: "loaderColor",
    error: "loaderColor",
    setField: "loaderColor",
  },
  endPoint: {
    name: "endPoint",
    error: "endPoint",
    setField: "endPoint",
  },
  endPointHeaders: {
    name: "endPointHeaders",
    error: "endPointHeaders",
    setField: "endPointHeaders",
  },
  gaTrackingId: {
    name: "gaTrackingId",
    error: "gaTrackingId",
    setField: "gaTrackingId",
  },
  gtmTrackingId: {
    name: "gtmTrackingId",
    error: "gtmTrackingId",
    setField: "gtmTrackingId",
  },
  landContentType: {
    name: "landContentType",
    error: "landContentType",
    setField: "landContentType",
  },
  landContainerContentColour: {
    name: "landContainerContentColour",
    error: "landContainerContentColour",
    setField: "landContainerContentColour",
  },
  landCustomContentColour: {
    name: "landCustomContentColour",
    error: "landCustomContentColour",
    setField: "landCustomContentColour",
  },
  landCustomContentFont: {
    name: "landCustomContentFont",
    error: "landCustomContentFont",
    setField: "landCustomContentFont",
  },
  groupForContact: {
    name: "contactGroup",
    error: "contactGroup",
    setField: "contactGroup",
  },
  sendersEmail: {
    name: "sendResponseInEmail.sendersEmail"
  },
  recipientsEmail: {
    name: "sendResponseInEmail.recipientsEmail"
  },
  subject: {
    name: "sendResponseInEmail.subject"
  },
  templateId: {
    name: "templateId",
    setField: "templateId",
  },
};

const errorFields = [
  fields.name.name,
  fields.background.name,
  fields.submitBackground.name,
  fields.landingPageBackground.name,
  fields.landingPageHtml.name,
  fields.thankyouPage.name,
  fields.usecase.name,
  fields.groupForContact.name,
  fields.endPoint.name,
  fields.sendersEmail.name,
  fields.recipientsEmail.name,
  fields.subject.name,
];

// mentions formik values type as any, as formik doesnt provide a type for it
function getError(fieldname: string, values: any) {
  return _.get(values.touched, fieldname) && _.get(values.errors, fieldname)
    ? _.get(values.errors, fieldname)
    : "";
}

// mentions formik values type as any, as formik doesnt provide a type for it
function getErrorStatus(values: any) {
  let errorOccuredFieldInCreateFormPopup = "";

  const hasErrorInCreateFormPopup = errorFields.every((field) => {
    if (_.get(values.errors, field)) {
      errorOccuredFieldInCreateFormPopup = field;
      return false;
    }

    return true;
  });

  return {
    errorOccuredFieldInCreateFormPopup,
    hasErrorInCreateFormPopup: !hasErrorInCreateFormPopup,
  };
}

// mentions formik values type as any, as formik doesnt provide a type for it
const traceFormikErrorField = (errorHandler: any, values: any) => {
  errorFields.every((field) => {
    if (Boolean(_.get(values.errors, field))) {
      errorHandler(field);
      return false;
    }

    return true;
  });
};

export { fields, errorFields, getError, getErrorStatus, traceFormikErrorField };
